<o-device-res-form (renewDevice)="emitRenewDevice()"
                   [device]="device"
                   [storedUser]="storedUser"></o-device-res-form>
